import React, { useState, useEffect } from "react";
import { Container, Grid, Segment, Header } from "semantic-ui-react";
import { useMediaQuery } from "react-responsive";
import DocumentationMenu from "./documentation-menu";
import DocumentationMobileMenu from "./documentation-mobile-menu";
import DocumentationContent from "./documentation-content";

const Documentation = () => {
  const [selectedItem, setSelectedItem] = useState("main");

  const handleItemClick = (e, { name }) => {
    setSelectedItem(name);
    window.history.pushState({}, "", `?doc=${name}`);
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const docParam = urlParams.get("doc");
    if (docParam) {
      setSelectedItem(docParam);
    }
  }, []);

  const isMobileOrTablet = useMediaQuery({ maxWidth: 1299 });

  return (
    <Container>
      <Header as="h1">User Documentation</Header>
      <Grid>
        <Grid.Row>
          {!isMobileOrTablet && (
            <Grid.Column width={3}>
              <DocumentationMenu
                selectedItem={selectedItem}
                handleItemClick={handleItemClick}
              />
            </Grid.Column>
          )}
          <Grid.Column width={isMobileOrTablet ? 16 : 13}>
            {isMobileOrTablet && (
              <DocumentationMobileMenu
                selectedItem={selectedItem}
                handleItemClick={handleItemClick}
              />
            )}
            <Segment style={{ padding: "2em" }}>
              <DocumentationContent selectedItem={selectedItem} />
            </Segment>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Container>
  );
};

export default Documentation;
